import React from 'react';
import { Box, Card, CardContent, Typography, Checkbox, Stack, Alert } from '@mui/material';
import MotionWrapper from '../../../../components/MotionWrapper';

const AvailableCartItemsForNextPayment = ({ data, selectedItems, setSelectedItems }) => {
  const handleCheck = (item) => {
    const isChecked = selectedItems.some((selected) => selected.cartId === item.cartId);

    if (isChecked) {
      setSelectedItems(selectedItems.filter((s) => s.cartId !== item.cartId));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  return (
    <Stack spacing={2}>
      <Alert severity="info">List of course enrollments available for next payment</Alert>
      {data?.length > 0 ? (
        data.map((item, i) => (
          <MotionWrapper direction={'top'} delay={i * 0.1}>
            <Card key={item.cartId} sx={{ bgcolor: 'grey.200' }}>
              <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="subtitle2">{item.courseName || 'No Course Name'}</Typography>

                <Checkbox
                  disabled={item.nextPaymentPermission == 1 ? false : true}
                  checked={selectedItems.some((s) => s.cartId === item.cartId)}
                  onChange={() => handleCheck(item)}
                />
              </CardContent>
            </Card>
          </MotionWrapper>
        ))
      ) : (
        <Typography>No pending items available</Typography>
      )}
    </Stack>
  );
};

export default AvailableCartItemsForNextPayment;
